import { IModificationInfo } from 'types/creationDetails'
import { IPaginationInfo, TSort } from './pagination'

export enum OrganizationType {
  TENDER_AUTHORITY = 'TENDER_AUTHORITY',
  CLIENT = 'CLIENT',
}

export type IOrganizationQueryInput = {
  type: OrganizationType
  name?: string
  email?: string
  taxId?: string
  size?: number
  sort?: TSort
}

export interface IOrganization extends IModificationInfo {
  id: string
  type: OrganizationType
  description: string
  taxId: string
  name: string
  email: string
  rootUserId: string
  active: boolean
  address: string
  phoneNumber: string
  executiveOfficerName: string
  countryCode?: string
  userRequest?: {
    firstName: string,
    lastName: string,
    pin: string,
    password: string
  }
}

export type IOrganizations = {
  info: IPaginationInfo
  items: IOrganization[]
}
